import { makeObservable, observable, action, computed } from 'mobx';

import AlertViewModel from '../Alert/viewModel';

export default class PurchaseAlertViewModel extends AlertViewModel {
  @observable courseId;
  @observable isPurchaseOnly = true;

  constructor(props) {
    super(props);
    makeObservable(this);
  }

  handlerOpenAlert = (cid) => {
    this.updateData(cid);
    this.toggleOverflow();
  }

  @action
  updateData = (cid) => {
    this.courseId = cid;
    // is cid exist => purchase only.
    this.isPurchaseOnly = !!cid;
    this.isOpenAlert = true;
  }
}
